import React from 'react'
import { motion } from "framer-motion";
import { FaShieldAlt, FaGem, FaCertificate, FaStar} from "react-icons/fa";

const Highlight = () => {

    const data = [
        {
            icon: <FaShieldAlt className="highlight-icon" />,
            text: "Over 20 Years of Customer Trust and Satisfaction",
        },
        {
            icon: <FaGem className="highlight-icon" />,
            text: "Exclusive Tanishq Franchise in Rajkot",
        },
        {
            icon: <FaCertificate className="highlight-icon" />,
            text: "Hallmarked Purity & Certified Diamonds",
        },
        {
            icon: <FaStar className="highlight-icon" />,
            text: "Bridal, Festive & Contemporary Collections",
        },
    ];

    return (
        <div>
            {/* Highlights Section */}
            <div div className="highlights-section py-5" >
                <section className="container text-center">
                    <h2 className="highlight-title mb-5">Our Highlights</h2>

                    <div className="row justify-content-center">
                        {data.map((item, index) => (
                            <div key={index} className="col-md-3 col-sm-6 mb-4 d-flex">
                                <motion.div
                                    className="highlight-card p-4 flex-fill d-flex flex-column justify-content-between"
                                    initial={{ opacity: 0, y: 40, scale: 0.95 }}
                                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                    viewport={{ once: false, amount: 0.3 }}
                                    transition={{ duration: 0.5, delay: index * 0.2 }}
                                >
                                    <div className="icon-wrapper">{item.icon}</div>
                                    <p className="highlight-text">{item.text}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Highlight